module.exports = __webpack_public_path__ + "img/imgSrc222.c67488df.png";